import React from 'react'
import i18next from 'i18next'
import {ColumnsType} from 'antd/es/table'
import {Tooltip} from 'antd'
import {DateTimeLabel, IconTitle, PaymentMethodOrMaskedCard, TableStatus} from '@/components'
import {BasePOSTransactionType, POSTransactionType} from '@/types/transactions/pos'
import {urls} from '@/constants/urls'
import {getAmountWithCurrency} from '@/utils'

import {
    getPOSPaymentMethod,
    getPOSPaymentStatusIconType,
    getPOSPaymentStatusName,
    getPOSPaymentStatusTagType,
    getPOSTransactionType
} from '.'
import {DccIconSvg} from '~/assets/icons'

export const getColumns = (): ColumnsType<BasePOSTransactionType> => {
    return [
        {
            title: i18next.t('pos-transaction.amount'),
            dataIndex: 'amount',
            key: 'amount',
            align: 'right' as any,
            width: 150,
            render: (_, item) => <b>{getAmountWithCurrency(item.amount, item.currency)}</b>
        },
        {
            title: () => (
                <IconTitle
                    title={i18next.t('pos-transaction.status')}
                    tooltipText={
                        <span>
                            {i18next.t('pos-transaction.statusTooltipPrefix')}
                            {urls.paymentStatusesGuide ? (
                                <>
                                    {' '}
                                    <a
                                        className='tooltip-inline-link'
                                        href={urls.paymentStatusesGuide}
                                        target='_blank'
                                        rel='noreferrer'
                                    >
                                        {i18next.t('pos-transaction.statusTooltipLink')}
                                    </a>
                                </>
                            ) : null}
                        </span>
                    }
                />
            ),
            dataIndex: 'status',
            key: 'status',
            align: 'left' as any,
            width: 200,
            render: (item, row) => (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}
                >
                    <div style={{width: 135}}>
                        <Tooltip title={getPOSPaymentStatusName(item)}>
                            <div>
                                <TableStatus
                                    statusProps={{
                                        status: getPOSPaymentStatusName(item),
                                        type: getPOSPaymentStatusTagType(item),
                                        iconType: getPOSPaymentStatusIconType(item)
                                    }}
                                />
                            </div>
                        </Tooltip>
                    </div>
                    {row.isDcc ? (
                        <div>
                            <Tooltip title={i18next.t('pos-transaction.dcc.title')}>
                                <DccIconSvg />
                            </Tooltip>
                        </div>
                    ) : null}
                </div>
            )
        },
        {
            title: i18next.t('pos-transaction.terminalId'),
            dataIndex: 'terminalId',
            key: 'terminalId',
            render: (item) => (item ? item : '-')
        },
        {
            title: i18next.t('pos-transaction.transaction.type'),
            dataIndex: 'transactionType',
            key: 'transactionType',
            render: (item, object) => getPOSTransactionType(object)
        },
        {
            title: i18next.t('pos-transaction.paymentMethod'),
            dataIndex: 'cardMask',
            key: 'cardMask',
            render: (_, item) => {
                const paymentMethod = getPOSPaymentMethod(item)
                return (
                    <PaymentMethodOrMaskedCard
                        paymentMethod={paymentMethod}
                        cardScheme={item.cardScheme}
                        cardMask={item.cardMask}
                    />
                )
            }
        },
        {
            title: i18next.t('pos-transaction.date'),
            dataIndex: 'transactionDate',
            key: 'transactionDate',
            width: 170,
            render: (item) => (item ? <DateTimeLabel date={item} /> : '-')
        }
    ]
}
